import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourProject from "./sections/StartYourProject";
import YourTeamOnTheGroundInChina from "./sections/YourTeamOnTheGroundInChina";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourProject />
      <YourTeamOnTheGroundInChina />
      <Footer />
    </div>;
}